import { useEffect } from "react";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import BigIdea from "../components/site/BigIdea";
import HowItWorks from "../components/site/HowItWorks";
import WhyDifferent from "../components/site/WhyDifferent";
import WhoItsFor from "../components/site/WhoItsFor";
import Genres from "../components/site/Genres";
import Producers from "../components/site/Producers";
import Teachers from "../components/site/Teachers";
import Packages from "../components/site/Packages";
import Lessons from "../components/site/Lessons";
import RevenueShare from "../components/site/RevenueShare";
import Vision from "../components/site/Vision";
import Footer from "../components/site/Footer";
import SmoothScroll from "../components/site/SmoothScroll";

export default function Landing() {
    useEffect(() => {
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return (
        <div className="relative min-h-screen bg-[#F1E8D5] text-[#0A0A0A]" data-testid="landing-page">
            <SmoothScroll />
            <div className="grain-overlay" aria-hidden="true" />
            <Nav />
            <main className="relative z-10">
                <Hero />
                <BigIdea />
                <HowItWorks />
                <WhyDifferent />
                <WhoItsFor />
                <Producers />
                <Genres />
                <Lessons />
                <Packages />
                <RevenueShare />
                <Teachers />
                <Vision />
            </main>
            <Footer />
        </div>
    );
}
